/**
 * predecessor-steps-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../../general/reply-message";
import { MessageTag } from "../../message-tag";

/**
 * When the server receives a {@link PredecessorStepsRequest}, it
 * responds with a {@link PredecessorStepsResponse} that enumerates the common
 * transitive predecessors of the algorithm steps named in the original
 * request.
 */
export class PredecessorStepsRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_PREDECESSOR_STEPS;
	public static tag : MessageTag = MessageTag.REQ_PREDECESSOR_STEPS;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_PREDECESSOR_STEPS);
  }

  /**
   * Construct a new {@link PredecessorStepsResponse}.
   *
   * @param ids
   *        The identifiers of the target algorithm steps.
   */
  constructor (public ids : number[])
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/graphs/predecessor-steps-request.ts